import React from 'react';

const HiddenFeatureToggle: React.FC = () => {
  const handleToggle = () => {
    //featureFlags.toggle('someFeature');
  };

  return (
    <div
      onDoubleClick={handleToggle}
      style={{
        width: '30px',
        height: '30px',
        cursor: 'help',
        zIndex: 9999,
        backgroundColor: 'transparent',
      }}
    />
  );
};

export default HiddenFeatureToggle;
